import { render, staticRenderFns } from "./Pension.vue?vue&type=template&id=1c0cdffc"
import script from "./Pension.vue?vue&type=script&lang=ts"
export * from "./Pension.vue?vue&type=script&lang=ts"
import style0 from "./Pension.vue?vue&type=style&index=0&id=1c0cdffc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports